import * as Dialog from "@/components/dialog/DialogLayout";
import { twMerge } from "@/utils/twMerge";

import type { ReactNode } from "react";

export function BillingSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section aria-label={title} className="flex flex-col mb-5">
      <Dialog.Subtitle title={title} className="mb-2.5" />
      {children}
    </section>
  );
}

export function BillingCard({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <div
      className={twMerge(
        "rounded-8 bg-block-bg shadow-block dark:shadow-block-inverted",
        "text-[15px] leading-[20px] tracking-tight",
        className,
      )}
    >
      {children}
    </div>
  );
}
